import { isObject } from "lodash";
import SocketWorker from "./SocketWorker"

export function socketConnection(params) {
  let userId = "";
  let companyId = "";
  if (isObject(params)){
    const identity = isObject(params.user) ? params.user : params;
    companyId = identity?.companyId
    userId = identity?.id ?? identity?.userId
  }
 
  return SocketWorker(companyId,userId)
}
